export const mh400 = '@media (max-height: 400px)';
export const mh600 = '@media (max-height: 600px)';
